// extracted by mini-css-extract-plugin
export default {"filterPopupHeader":"filterHeader_filterPopupHeader__EDCgK","filterPopupHeaderTitle":"filterHeader_filterPopupHeaderTitle__CTsXw","closeBtn":"filterHeader_closeBtn__2n2iL"};